import { apiClient } from './apiClient';

const createUser = async (data) => {
  return await apiClient.post('/auth/register', data);
};

const loginUser = async (data) => {
  return await apiClient.post('/auth/login', data);
};

const forgotPassword = async (data) => {
  return await apiClient.post('/auth/forgot', data);
};

const resetPassword = async (data) => {
  return await apiClient.post('/auth/reset', data);
};

export const authApi = {
  createUser,
  loginUser,
  forgotPassword,
  resetPassword,
};
